import { AfiliadoCard } from '@/features/home/components/afiliado-card/afiliado-card';

interface SeccionSociosProps {
  titulo?: string;
  subtitulo?: string;
}

const LOGOS = [1, 2, 3, 4, 5];

export function SeccionSocios({
  subtitulo = 'Colaboramos con las mejores empresas del sector para ofrecerte un servicio excepcional.',
}: SeccionSociosProps): React.ReactElement {
  return (
    <section className="from-background via-muted/30 to-primary/5 bg-linear-to-br py-16">
      <div className="container mx-auto px-6 lg:px-12 xl:px-16 2xl:px-24">
        <div className="mb-10 text-center">
          <h2 className="text-foreground mb-4 text-3xl leading-tight font-bold md:text-4xl">
            Nuestros{' '}
            <span className="from-primary to-secondary bg-linear-to-r bg-clip-text text-transparent">
              Socios
            </span>
          </h2>

          <p className="text-muted-foreground mx-auto max-w-2xl text-base leading-relaxed lg:text-lg">
            {subtitulo}
          </p>
        </div>

        <div className="mx-auto max-w-6xl">
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 md:grid-cols-5 md:gap-8 lg:gap-10">
            {LOGOS.map((imagenId, index) => (
              <div
                key={imagenId}
                className="transform transition-all duration-700 hover:scale-105"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <AfiliadoCard imagenId={imagenId} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
